import React, { FC, memo, useContext, useMemo } from 'react'
import { ScreenContext } from 'react-components'

import {
    Container,
    CardsContainer,
    StyledCarouselProvider,
    StyledSlider,
    StyledSlide,
    Section,
    TitleContainer,
} from './styles'
import { TipSectionTransport } from '../../../transports/region-landing-page-transport'
import { useTranslation } from '../../../hooks/locale'
import TipsSectionCard from './tips-section-card'
import { Subtitle, Title } from '../common/styles'

interface TipsProps {
    tipsSection: TipSectionTransport
    location: string
}

const TipsSection: FC<TipsProps> = ({ tipsSection, location }) => {
    const { heading, tips } = tipsSection
    const { t } = useTranslation()
    const { isDesktop, isMobile } = useContext(ScreenContext)

    const tipsSectionHeading = heading ? heading : `${t('tipsSectionHeading')} ${location}`
    const subheading = `${t('tipsSectionSubHeading')}${location}`

    const tipsSectionItems = useMemo(
        () =>
            tips.map((tip, index) => {
                return !isDesktop ? (
                    <StyledSlide key={tip.title} index={index}>
                        <TipsSectionCard tip={tip} location={location} />
                    </StyledSlide>
                ) : (
                    <TipsSectionCard key={tip.title} tip={tip} location={location} />
                )
            }),
        [tips, location, isDesktop],
    )

    return (
        <Section id="tips">
            <Container>
                <TitleContainer>
                    <Title>{tipsSectionHeading}</Title>
                    <Subtitle>{subheading}</Subtitle>
                </TitleContainer>

                <CardsContainer>
                    {!isDesktop ? (
                        <StyledCarouselProvider
                            totalSlides={tipsSectionItems.length}
                            visibleSlides={isMobile ? 1.1 : 1.7}
                            naturalSlideWidth={1}
                            naturalSlideHeight={1}
                            isIntrinsicHeight
                            lockOnWindowScroll
                            dragStep={1}
                            step={1}
                        >
                            <StyledSlider>{tipsSectionItems}</StyledSlider>
                        </StyledCarouselProvider>
                    ) : (
                        tipsSectionItems
                    )}
                </CardsContainer>
            </Container>
        </Section>
    )
}

export default memo(TipsSection)
